<template>
  <div id="app" class="app" :style="bgImgStyle">
    <div
      class="spinner-wrapper d-flex justify-content-center align-items-center"
      v-if="isLoading"
    >
      <div class="loader"></div>
    </div>
    <router-view v-if="!isLoading" />
    <b-modal
      id="dialogModal"
      :title="modalText.title"
      ok-only
      :ok-title="$t('okey')"
    >
      <p class="my-4">{{ modalText.message }}</p>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { auth, db } from '@/firebase';

import axios from 'axios';
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      modalText: {},
      isLoading: true,
      bgImgStyle: {},
      selectedLang: 'en',
    };
  },
  computed: {
    ...mapGetters({
      streamList: 'stream/list',
      user: 'user/current',
      event: 'event/current',
      stream: 'stream/current',
      appSettings: 'appsettings/current',
    }),
  },
  methods: {
    ...mapActions({
      setCurrentEvent: 'event/setCurrent',
      setCurrentUser: 'user/setCurrent',
      setStreamList: 'stream/setList',
      setCurrentStream: 'stream/setCurrent',
      getAppSettings: 'appsettings/get',
    }),
    async signInWithMagnetToken() {
      const data = await axios({
        method: 'GET',
        url: `${process.env.VUE_APP_BASE_URL}/registration/me`,
        headers: { Authorization: `Bearer ${this.$route.query.t}` },
      });
      return data;
    },
    async signInFromLocalStorage() {
      const token = localStorage.getItem(this.$route.params.slug);
      const data = await axios({
        method: 'GET',
        url: `${process.env.VUE_APP_BASE_URL}/registration/me`,
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
  },
  async mounted() {
    let data = null;

    // get app Settings
    await this.getAppSettings();

    // Fetch event and registration data
    try {
      if (this.$route.query.t) {
        data = await this.signInWithMagnetToken();
      } else {
        data = await this.signInFromLocalStorage();
      }

      this.setCurrentUser(data.data.registration);
      this.setCurrentEvent(data.data.event);
      document.title = data.data.event.title;
      this.setStreamList(data.data.streams);
      this.setCurrentStream(data.data.streams[0]);
      console.log(this.$route);
    } catch (error) {
      console.log(error);
      this.modalText = {
        title: 'Error!',
        message: this.$t('registration_required'),
      };
      this.$bvModal.show('dialogModal');
      if (_.has(this.$route, 'params.slug')) {
        window.location = `${this.appSettings.general.landingUrl}/${this.$route.params.slug}`;
      }

      return false;
    }

    // signin via firebase
    try {
      await auth().signInWithCustomToken(this.user.fbToken);
      // if signin completed, remove the token from address bar
      if (this.$route.name === 'Live') {
        this.$router.push(`/${this.event._id}`).catch(() => {});
      }
    } catch (err) {
      this.modalText = {
        title: 'Error!',
        message: 'Invalid access.',
      };
      this.$bvModal.show('dialogModal');
      return false;
    }

    // Put token to the localStorage for further page refresh
    localStorage.setItem(this.event._id, this.user.token);

    // assign background image

    // listen auth changes and refresh the token if necessary
    auth().onAuthStateChanged(async (user) => {
      if (!user) {
        const {
          data: { fbToken },
        } = await axios({
          method: 'GET',
          url: `${process.env.VUE_APP_BASE_URL}/refresh`,
          headers: { Authorization: `Bearer ${this.user.token}` },
        });

        await auth().signInWithCustomToken(fbToken);
      }
    });

    // listen event status updates
    db.collection('event')
      .doc(this.event._id)
      .onSnapshot({}, (doc) => {
        this.setCurrentEvent(Object.assign(this.event, doc.data()));
        this.isLoading = false;
      });

    return true;
  },
};
</script>
<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
}
.app {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;

  height: 100%;
  overflow-y: scroll;
}

.spinner-wrapper {
  width: 100vw;
  height: calc(100vh - 96px);
}

.loader,
.loader:after {
  border-radius: 100%;
  width: 64px;
  height: 64px;
}
.loader {
  position: relative;
  border-top: 4px solid rgba(0, 0, 0, 0.1);
  border-right: 4px solid rgba(0, 0, 0, 0.1);
  border-bottom: 4px solid #007bff;
  border-left: 4px solid #007bff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 0.6s infinite linear;
  animation: load8 0.6s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.footer {
  width: 100%;
  background-color: #ececec;
  padding: 0px 16px 1px;
  margin-top: 32px;
  .lang-select-wrapper {
    width: 150px;
  }
  .col-form-label-sm {
    line-height: 0;
    z-index: 100;
    position: relative;
    font-size: 10px;
    left: 13px;
    color: #007bff;
    top: 25px;
  }
  #page-lang {
    padding: 0.975rem 1.75rem 0.275rem 0.75rem;
    height: auto;
  }
}
</style>
